<template>

  <div>

    <b-modal id="updateAccumulatorsModal" >
        <div class="loading_page" v-if="uaIsBusy">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
        </div>
        <b-row class="mt-2">
            <b-col cols="12" md="6">
              <b-form-group :label="$t('DEVICES_UPDATE_ACCUMULATORS_DISTANCE_LABEL')">
                <b-input-group class="input-group-merge">
                  <b-form-input 
                    id="ua-distance"
                    :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                    v-model="uaDistance"
                    :placeholder="$t('DEVICES_UPDATE_ACCUMULATORS_DISTANCE_PLACEHOLDER')" 
                    :state="uaDistanceHasValidationError() ? false : null"
                  />
                </b-input-group>
                <small v-if="uaDistanceHasValidationError" class="text-danger">
                  {{ $t(uaDistanceValidationError()) }}
                </small>
              </b-form-group>

              <b-form-group :label="$t('DEVICES_UPDATE_ACCUMULATORS_HOURS_LABEL')">
                <b-input-group class="input-group-merge">
                  <b-form-input 
                    id="ua-hours"
                    :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                    v-model="uaHours"
                    :placeholder="$t('DEVICES_UPDATE_ACCUMULATORS_HOURS_PLACEHOLDER')" 
                    :state="uaHoursHasValidationError() ? false : null"
                  />
                </b-input-group>
                <small v-if="uaHoursHasValidationError()" class="text-danger">
                  {{ $t(uaHoursValidationError()) }}
                </small>
              </b-form-group>
            </b-col>
        </b-row>
        <template #modal-footer="{close}">
          <b-button @click="close()">
            {{ $t('DIALOGUE_CLOSE_LABEL') }}
          </b-button>
          <b-button @click="updateAccumulators(close)">
            {{ $t('DIALOGUE_SUBMIT_LABEL') }}
          </b-button>
        </template>
      </b-modal>

      <devices-import v-if="hasPermission('devices.create')" />

    <!-- Filters -->
    <devices-list-filters :categories-options="categoriesOptions" :contracts-options="contractsOptions"
      :groups-options="groupsOptions" :owners-options="ownersOptions" :types-options="typesOptions"
      :categories-filter.sync="categoriesFilter" :type-filter.sync="typeFilter" :group-filter.sync="groupFilter"
      :owners-filter.sync="ownersFilter" 
      :contracts-filter.sync="contractsFilter"
      :isSupportFilter.sync="isSupportFilter"
      
      >
    </devices-list-filters>

    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="loading_page" v-if="requestStatus">
        <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
      </div>

      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col cols="12" md="3" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>{{ $t('Show') }}</label>
            <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions"
              :clearable="false" class="per-page-selector d-inline-block mx-50" />
            <label>{{ $t('entries') }}</label>
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="9">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search...')" />
              <b-button v-if="hasPermission('devices.create')" variant="primary" :to="{name: 'devices.create'}">
                <span class="text-nowrap"> {{ $t('Create Device')}}</span>
              </b-button>

              <div v-if="$store.state.auth.userData.roles.includes($roles.SUPER_ADMIN)">
                <input type="file" hidden ref="importFileInput" @input="importFile"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
              </div>

              <b-button  class="mr-1 ml-1" variant="info" v-b-modal.importModal type="button"  v-if="hasPermission('devices.create')">
                  {{ $t('Import') }}
              </b-button>

              <b-button class="mr-1 ml-1" variant="info" @click.prevent="Export('pdf')" type="button">
                {{ $t('Export PDF') }}
              </b-button>

              <b-button @click.prevent="Export('xlsx')" type="button" class="mr-1 ml-1" variant="info">
                {{ $t('Export Excel') }}
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table ref="refDeviceListTable" class="position-relative" style="/* 'this style collision with responsive' overflow: visible*/" :items="fetchDevices" responsive
        :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty
        :empty-text="$t('No matching records found')" :sort-desc.sync="isSortDirDesc">

        <!--        &lt;!&ndash; Column: User &ndash;&gt;-->
        <!--        <template #cell(user)="data">-->
        <!--          <b-media vertical-align="center">-->
        <!--            <template #aside>-->
        <!--              <b-avatar-->
        <!--                size="32"-->
        <!--                :src="data.item.avatar"-->
        <!--                :text="avatarText(data.item.name)"-->
        <!--                :variant="`light-${resolveUserRoleVariant(data.item.role)}`"-->
        <!--                :to="{ name: 'apps-users-view', params: { id: data.item.id } }"-->
        <!--              />-->
        <!--            </template>-->
        <!--            <b-link-->
        <!--              :to="{ name: 'apps-users-view', params: { id: data.item.id } }"-->
        <!--              class="font-weight-bold d-block text-nowrap"-->
        <!--            >-->
        <!--              {{ data.item.name }}-->
        <!--            </b-link>-->
        <!--            <small class="text-muted">@{{ data.item.name }}</small>-->
        <!--          </b-media>-->
        <!--        </template>-->

        <!-- Column: Role -->
        <!--        <template #cell(role)="data">-->
        <!--          <div class="text-nowrap">-->
        <!--            <feather-icon-->
        <!--              :icon="resolveUserRoleIcon(data.item.role)"-->
        <!--              size="18"-->
        <!--              class="mr-50"-->
        <!--              :class="`text-${resolveUserRoleVariant(data.item.role)}`"-->
        <!--            />-->
        <!--            <span class="align-text-top text-capitalize">{{ data.item.role }}</span>-->
        <!--          </div>-->
        <!--        </template>-->


        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown class="actionIcon" variant="link" no-caret :right="$store.state.appConfig.isRTL">
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
            </template>
            <b-dropdown-item :to="{ name: 'devices.edit', params: { id: data.item.id } }"
              v-if="$store.state.auth.userData.permissions.includes('devices.edit')">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">{{ $t('Edit') }}</span>
            </b-dropdown-item>
            <b-dropdown-item v-b-modal.updateAccumulatorsModal @click="() => uaSetDeviceId(data.item.id)"
              v-if="$store.state.auth.userData.permissions.includes('devices.updateAccumulators')">
              <feather-icon icon="ClockIcon" />
              <span class="align-middle ml-50">{{ $t('DEVICES_UPDATE_ACCUMULATORS_LABEL')}}</span>
            </b-dropdown-item>
            <b-dropdown-item @click="removeDevice(data.item.id)"
              v-if="$store.state.auth.userData.permissions.includes('devices.destroy')">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">{{ $t('Delete')}}</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>


      <div class="mx-2 mb-2">
        <b-row>
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted">{{ $t('Showing') }} {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }}
              {{$t('entries')}}</span>
          </b-col>
          <!-- Pagination -->
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
            <b-pagination v-model="currentPage" :total-rows="totalDevices" :per-page="perPage" first-number last-number
              class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>

        </b-row>
      </div>
    </b-card>

  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, VBModal,BModal,BFormGroup,BInputGroup
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import DevicesListFilters from '@/views/modules/device/devices-list/DevicesListFilters'
import useDevicesList from '@/views/modules/device/devices-list/useDevicesList'
import { OrbitSpinner } from 'epic-spinners'
import deviceStoreModule from '../deviceStoreModule'
import { hasPermission } from '@/auth/utils'
import Ripple from 'vue-ripple-directive'
import useUpdateAccumulators from '../useUpdateAccumulators'
import devicesImport from './devices-Import.vue'

export default {
  components: {
    DevicesListFilters,
    OrbitSpinner,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
    BModal,
    BFormGroup,
    BInputGroup,
    devicesImport
  },

  directives: {
    'b-modal': VBModal,
    Ripple,
  },


  setup(props, { root }) {

    const importFileInput = ref(null)

    const DEVICE_APP_STORE_MODULE_NAME = 'app-device'

    // Register module
    if (!store.hasModule(DEVICE_APP_STORE_MODULE_NAME))
      store.registerModule(DEVICE_APP_STORE_MODULE_NAME, deviceStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(DEVICE_APP_STORE_MODULE_NAME))
        store.unregisterModule(DEVICE_APP_STORE_MODULE_NAME)
    })

    const importFile = () => {

      const form = new FormData()

      form.append('file', importFileInput.value.files[0])

      store.dispatch('app-device/importFile', form)
        .then(res => { }).catch(reason => console.log(reason))

      importFileInput.value = null
    }

    const removeDevice = id => {

      root.$swal({
        title: root.$i18n.t("Are You Sure"),
        text: root.$i18n.t("the delete of device cause all related plane to be deleted,continue?"),
        showCancelButton: true,
        confirmButtonText: root.$i18n.t('Delete'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          requestStatus.value = true
          store.dispatch('app-device/deleteDevice', id)
            .then(_ => {
              refetchData()
              root.$bvToast.toast(
                root.$i18n.t('Device Deleted Successfully'), {
                title: root.$i18n.t('Success'),
                variant: 'success',
                solid: true,
              })
            }).catch(reason => console.log(reason))
        }
      })
    }


    const {
      fetchDevices,
      tableColumns,
      perPage,
      currentPage,
      totalDevices,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDeviceListTable,
      refetchData,

      // filters
      ownersOptions,
      categoriesOptions,
      typesOptions,
      groupsOptions,
      contractsOptions,
      contractsOptions_orig,

      typeFilter,
      groupFilter,
      contractsFilter,
      isSupportFilter,
      ownersFilter,
      categoriesFilter,

      // UI
      requestStatus,
      Export,

    } = useDevicesList()


    const {
      uaDeviceId,
      uaDistance,
      uaHours,
      uaDistanceHasValidationError,
      uaDistanceValidationError,
      uaHoursHasValidationError,
      uaHoursValidationError,
      uaSetDeviceId,
      uaIsBusy,
      uaSubmit
    } = useUpdateAccumulators()

    const updateAccumulators = (closeModal) => {
      uaSubmit(()=> {
        closeModal()
        root.$bvToast.toast(
            root.$i18n.t('DEVICES_UPDATE_ACCUMULATORS_SUCCESS_MESSAGE'), 
            {
              title: root.$i18n.t('Success'),
              variant: 'success',
              solid: true
            }
        )
      })
    }

    return {
      importFileInput,
      importFile,
      removeDevice,
      requestStatus,
      fetchDevices,
      tableColumns,
      perPage,
      currentPage,
      totalDevices,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDeviceListTable,
      refetchData,


      // Filter
      avatarText,
      ownersOptions,
      categoriesOptions,
      typesOptions,
      groupsOptions,
      contractsOptions,

      typeFilter,
      groupFilter,
      contractsFilter,
      ownersFilter,
      categoriesFilter,
      isSupportFilter,


      hasPermission,
      Export,

      uaDeviceId,
      uaDistance,
      uaHours,
      uaDistanceHasValidationError,
      uaDistanceValidationError,
      uaHoursHasValidationError,
      uaHoursValidationError,
      uaSetDeviceId,
      uaIsBusy,
      updateAccumulators
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.table > tbody > tr > td {
max-width:150px !important;

}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.actionIcon>button {
  padding: 0;
}
.table > tbody > tr > td {
max-width:200px;

}


</style>
